import { OBJECT, STRING, ARRAY, INTEGER, NUMBER, BOOLEAN, NULL } from './types';
import {
  DefaultTypeObject,
  DefaultTypeArray,
  DefaultTypeString,
  DefaultTypeInteger,
  DefaultTypeNumber,
  DefaultTypeBoolean,
  DefaultTypeNull,
} from './defaults';

export const createDefinitions = () => ({
  [OBJECT]: {
    default: DefaultTypeObject,
    customs: [],
  },
  [ARRAY]: {
    default: DefaultTypeArray,
    customs: [],
  },
  [STRING]: {
    default: DefaultTypeString,
    customs: [],
  },
  [INTEGER]: {
    default: DefaultTypeInteger,
    customs: [],
  },
  [NUMBER]: {
    default: DefaultTypeNumber,
    customs: [],
  },
  [BOOLEAN]: {
    default: DefaultTypeBoolean,
    customs: [],
  },
  [NULL]: {
    default: DefaultTypeNull,
    customs: [],
  },
});

export default createDefinitions;
